module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Genf_matt-db31a59f7aa7ae09181bbaaa66582afe.svg";